// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"style_main-layout__z30kb","slide-wrapper":"style_slide-wrapper__JPfLt","next-button":"style_next-button__u504m","prev-button":"style_prev-button__6dtWO"};